import React, { useState, useEffect } from 'react';
import { ScoreViewProps } from 'business/models/CustomModels';
import RenderScore from 'components/scores/scoreRenderer';

const ScoreView = ({ scoresDetail, plate }: ScoreViewProps) => {
  const [scores, setScores] = useState([]);

  useEffect(() => {
    function createScores(scoresData) {
      const cells = [];
      for (let iter = 0; iter < scoresData.length; iter++) {
        if (scoresData[iter].length > 0) {
          const wellRect = plate.wellRects[scoresData[iter][0].wellNumber - 1];
          cells.push(
            <RenderScore
              rect={wellRect}
              scores={scoresData[iter]}
              key={`scoresKey-${iter}`}
            />,
          );
        }
      }
      return cells;
    }

    setScores(createScores(scoresDetail));
  }, [scoresDetail]);

  return <>{scores}</>;
};

export default ScoreView;
